// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-4c166d201a7c3daf.css";
if (chunkId === "7350") return "css/7350-c4fb6e03132e1a07.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"1009": "cf702b05f37031f5","1632": "6b3ff39c47ca4ec9","193": "dfc6006df535e744","2390": "7883655edc831929","2429": "a73d2fa285645c40","2513": "6a4fa745f2459857","2717": "c5820b193c3b10f0","6580": "a892af76eb78c2e8","9896": "a8d311b114ec77ce",}[chunkId] + ".css"
}